// @flow
const showServerError = (error: any) =>
  error?.networkError && 'result' in error.networkError
    ? error.networkError.result.messages?.[0]?.message
    : '';

export default showServerError;
